import { getField, updateField } from 'vuex-map-fields'
import { getNewId } from '@/utils/id'
import BaseBoundaryCondition from './baseBoundaryCondition'
import api from '../api/api'

export const namespaced = true

let baseUrl = '/crest_level_boundary_conditions/'
let paginationUrl = '/reference_point_crest_level_boundary_conditions/'
let yearSet = {}

const baseBoundaryCondition = new BaseBoundaryCondition(baseUrl, paginationUrl)

const getDefaultState = () => {
  return {
    ...structuredClone(baseBoundaryCondition.state),
    overtoppingRates: [],
    importOverToppingRates: [],
    importedYears: [],
    ignoredReferencePoint: [],
    templateFileName: 'Crest_level.xlsx'
  }
}
export const state = getDefaultState()

export const mutations = {
  ...baseBoundaryCondition.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  SET_IMPORT_OVERTOPPING_RATES(state, items) {
    state.importOverToppingRates = [...items]
  },
  ADD_IGNORE_REFERENCE_POINT(state, items) {
    state.ignoredReferencePoint = items
  },
  SET_OVERTOPPING_RATES(state, overtoppingRates) {
    state.overtoppingRates = overtoppingRates
  },
  RESET_IMPORT_STATE(state) {
    state.importItems = []
    state.uploadLoading = false
    state.importLoading = false
    state.ignoredReferencePoint = []
    state.importOverToppingRates = []
    state.importedYears = []
  },
  updateField
}
export const actions = {
  ...baseBoundaryCondition.actions,
  async fetchCrestLevelOvertoppingRates(context) {
    let url = `${baseUrl}overtopping_rate_options/?search=${context.rootState.project.currentProject.id}`
    let response = await api.get(url)
    context.commit('SET_OVERTOPPING_RATES', response['data'])
  },
  getNewCrestLevelBoundaryConditions(context, referencePointId) {
    let crestLevelBoundaryConditions = []
    let ids = []
    let years = context.rootState.project.currentProject.year_set
    if (context.state.years.length) {
      years = context.state.years
    }
    years.forEach((year) => {
      context.state.options.slope.choices.forEach((slope) => {
        context.state.overtoppingRates.forEach((overtoppingRate) => {
          let id = getNewId(context.getters.getItems, 'id', ids)
          crestLevelBoundaryConditions.push(
            context.getters.getEmptyCrestLevelBoundaryCondition(
              id,
              referencePointId,
              year.id,
              slope.value,
              overtoppingRate.value
            )
          )
          ids.push(id)
        })
      })
    })
    return crestLevelBoundaryConditions
  },
  async addNewItem(context) {
    let referencePointId = getNewId(context.getters.getItems, 'reference_point')
    let crestLevelHydraulicBoundaryConditions = await context.dispatch(
      'getNewCrestLevelBoundaryConditions',
      referencePointId
    )
    let newItem = {
      id: referencePointId,
      reference_point: referencePointId,
      crestlevelboundarycondition_set: crestLevelHydraulicBoundaryConditions
    }
    context.commit('ADD_ITEM', newItem)
    context.commit('ADD_COUNT', 1)
  },
  async uploadFile(context, formData) {
    formData.append('project_id', context.rootGetters['project/selectedProjectId'])
    context.commit('TOGGLE_UPLOAD_LOADING')
    try {
      let response = await api.post(paginationUrl + 'bulk_upload/', formData)
      let responseData = response['data']['results']
      let dataImport = []
      let list_overtopping_rate = response['data']['list_overtopping_rate']
      let option_overtopping_rate = []
      list_overtopping_rate.forEach((item) => {
        option_overtopping_rate.push({ display_name: item, value: item })
      })
      context.commit('SET_IMPORT_OVERTOPPING_RATES', option_overtopping_rate)
      context.commit('SET_IMPORTED_YEARS', response['data']['file_year'])
      context.rootState.project.currentProject.year_set.forEach((year) => {
        yearSet[year.id] = year.year
      })
      if (responseData.length) {
        for (let idx = 0; idx < responseData.length; idx++) {
          let crestLevel = responseData[idx]['crestlevelboundarycondition_set']
          dataImport.push(sortData(responseData[idx], crestLevel))
        }
      }
      context.commit('ADD_IMPORT_ITEMS', dataImport)
      context.commit('ADD_IGNORE_REFERENCE_POINT', response.data['ignored_reference_point'])
      context.commit('SET_DELETE_WARNING', response.data['delete_warning'])
      context.commit('TOGGLE_UPLOAD_LOADING')
    } catch (e) {
      console.log(e)
      context.commit('TOGGLE_UPLOAD_LOADING')
    }
  },
  setState(context) {
    context.commit('SET_OVERTOPPING_RATES', context.state.importOverToppingRates)
  }
}

export const getters = {
  getField,
  getEmptyCrestLevelBoundaryCondition:
    (state) => (id, referencePointId, yearId, slope, overtoppingRate) => {
      let emptyObj = {}
      Object.keys(state.options).forEach((key) => (emptyObj[key] = ''))
      emptyObj.id = id
      emptyObj.year = yearId
      emptyObj.slope = slope
      emptyObj.overtopping_rate = overtoppingRate
      emptyObj.reference_point = referencePointId
      return emptyObj
    },
  getExportFileName: (state, getters, rootState) => {
    let projectName = rootState['project'].currentProject?.name
    return projectName + '_CrestLevel_export.xlsx'
  },
  getItems: (state) => {
    let crestLevelBoundaryConditions = []
    state.items.forEach((referencePoint) =>
      crestLevelBoundaryConditions.push(...referencePoint.crestlevelboundarycondition_set)
    )
    return crestLevelBoundaryConditions
  }
}

function sortData(general, crestLevel) {
  const list_slope = ['current', '1:2', '1:3']

  let slope_current = crestLevel.filter((item) => item.slope == list_slope[0])
  let slope_1_2 = crestLevel.filter((item) => item.slope == list_slope[1])
  let slope_1_3 = crestLevel.filter((item) => item.slope == list_slope[2])
  slope_current.sort(sortCrestLevel)
  slope_1_2.sort(sortCrestLevel)
  slope_1_3.sort(sortCrestLevel)
  let sortedCrestLevel = [...slope_current, ...slope_1_2, ...slope_1_3]
  return {
    ...general,
    crestlevelboundarycondition_set: sortedCrestLevel
  }
}

function sortCrestLevel(a, b) {
  if (a.overtopping_rate > b.overtopping_rate) return 1
  if (a.overtopping_rate < b.overtopping_rate) return -1
  if (yearSet[a.year.toString()] < yearSet[b.year.toString()]) return -1
  if (yearSet[a.year.toString()] > yearSet[b.year.toString()]) return 1
  return 0
}
